import React from "react";
import { createStackNavigator } from "@react-navigation/stack";

import Welcome from "../views/welcome";
import Login from "../views/login";
import TermsService from "../views/TermsService";
import Register from "../views/register";
import Home from "../views/Home";
import MyAccount from "../views/MyAccount";
import Tabs from "../views/Tabs";
import UpdateRegistration from "../views/UpdateRegistration";
import ReportIncome from "../views/ReportIncome";
import DeleteAccount from "../views/DeleteAccount";
import IncomeVoucher from "../views/IncomeVoucher";
import Exchange from "../views/Exchange";
import Marketplace from "../views/Marketplace";
import Token from "../views/Token";
import BankAccount from "../views/BankAccount";
import NewBankAccount from "../views/NewBankAccount";
import EditBankAccount from "../views/EditBankAccount";
import ChangePassword from "../views/ChangePassword";
import NewPassword from "../views/NewPassword";
import MyCards from "../views/MyCards";
import NewCard from "../views/NewCard";
import EditCard from "../views/EditCard";
import DeleteCard from "../views/DeleteCard";
import MarketplaceCategories from "../views/MarketplaceCategories";
import DetailsCoin from "../views/DetailsCoin";
import MoreInfosCoin from "../views/MoreInfosCoin";
import MyBalance from "../views/MyBalance";
import ConfirmPassword from "../views/ConfirmPassword";
import SellExchange from "../views/SellExchange";
import ConfirmSell from "../views/ConfirmSell";
import Purchase from "../views/Purchase";
import ConfirmPurchase from "../views/ConfirmPurchase";
import PaymentMethod from "../views/PaymentMethod";
import BankSlip from "../views/BankSlip";
import CreditCardPayment from "../views/CreditCardPayment";
import Transfer from "../views/Transfer";
import PaymentMethodTransfer from "../views/PaymentMethodTransfer";
import SearchUsers from "../views/SearchUsers";
import ConfirmSearchUser from "../views/ConfirmSearchUser";
import SelectPixKey from "../views/SelectPixKey";
import PhonePix from "../views/PhonePix";
import EmailPix from "../views/EmailPix";
import IdentityDocumentPix from "../views/IdentityDocumentPix";
import RandomKeyPix from "../views/RandomKeyPix";
import BankAccountPix from "../views/BankAccountPix";
import QrCodeTransferPix from "../views/QrCodeTransferPix";
import QrCodeConfirmTransferPix from "../views/QrCodeConfirmTransferPix";
import PaymentMethodPay from "../views/PaymentMethodPay";
import QrCodePay from "../views/QrCodePay";
import QrCodeConfirmPay from "../views/QrCodeConfirmPay";
import BarCodePay from "../views/BarCodePay";
import BarCodeConfirmPay from "../views/BarCodeConfirmPay";
import Sell from "../views/Sell";
import PaymentMethodSell from "../views/PaymentMethodSell";
import ConfirmSearchUserSell from "../views/ConfirmSearchUserSell";
import Cashback from "../views/Cashback";
import MyQualification from "../views/MyQualification";
import LevelUpdate from "../views/LevelUpdate";
import InvestorProfile from "../views/InvestorProfile";
import PurchaseMkt from "../views/PurchaseMkt";
import Certificates from "../views/Certificates";
import CertificatesEmit from "../views/CertificatesEmit";
import BuyExchange from "../views/BuyExchange";
import BuyToken from "../views/BuyToken";
import DepositMethod from "../views/DepositMethod";
import DepositGPXAmount from "../views/DepositGPXAmount";
import DepositPaymentMethod from "../views/DepositPaymentMethod";
import DepositPix from "../views/DepositPix";
import DepositBoleto from "../views/DepositBoleto";
import DepositCreditCard from "../views/DepositCreditCard";
import DepositNewCreditCard from "../views/DepositNewCreditCard";
import DepositCreditCardSummary from "../views/DepositCreditCardSummary";
import DepositCryptoSelection from "../views/DepositCryptoSelection";
import DepositCrypto from "../views/DepositCrypto";
import WithdrawMethod from "../views/WithdrawMethod";
import WithdrawGPXAccountSelection from "../views/WithdrawGPXAccountSelection";
import WithdrawGPX from "../views/WithdrawGPX";
import WithdrawCrypto from "../views/WithdrawCrypto";
import WithdrawCryptoSelection from "../views/WithdrawCryptoSelection";
import WithdrawCryptoPassword from "../views/WithdrawCryptoPassword";
import WithdrawGPXPassword from "../views/WithdrawGPXPassword";
import ConfirmPurchaseOrSell from "../views/ConfirmPurchaseOrSell";
import ConfirmPasswordPurchaseOrSell from "../views/ConfirmPasswordPurchaseOrSell";
import TransferFindUser from "../views/TransferFindUser";
import ConfirmTransfer from "../views/ConfirmTransfer";
import ConfirmPasswordTransfer from "../views/ConfirmPasswordTransfer";
import PaperWallet from "../views/PaperWallet";
import ConfirmPaperWallet from "../views/ConfirmPaperWallet";
import ConfirmPasswordPaperWallet from "../views/ConfirmPasswordPaperWallet";
import PaperWalletDeposit from "../views/PaperWalletDeposit";


const stackRoutes = createStackNavigator();

const PageRoutes = () => (
  <stackRoutes.Navigator headerMode="screen" screenOptions={{ headerShown: false }}>
    <stackRoutes.Screen name="Welcome" component={Welcome} options={{ title: 'Bem-vindo' }} />
    <stackRoutes.Screen name="Login" component={Login} options={{ title: 'Entrar' }} />
    <stackRoutes.Screen name="Register" component={Register} options={{ title: 'Cadastro' }} />
    <stackRoutes.Screen name="TermsService" component={TermsService} />
    <stackRoutes.Screen name="Home" component={Home} options={{ title: 'Início' }} />
    <stackRoutes.Screen name="MyAccount" component={MyAccount} options={{ title: 'Minha conta' }} />
    <stackRoutes.Screen name="Tabs" component={Tabs} options={{ title: 'Home' }} />
    <stackRoutes.Screen name="UpdateRegistration" component={UpdateRegistration} options={{ title: 'Atualizar cadastro' }} />
    <stackRoutes.Screen name="ReportIncome" component={ReportIncome} options={{ title: 'Declarar renda' }} />
    <stackRoutes.Screen name="DeleteAccount" component={DeleteAccount} options={{ title: 'Excluir conta' }} />
    <stackRoutes.Screen name="IncomeVoucher" component={IncomeVoucher} options={{ title: 'Voucher' }} />
    <stackRoutes.Screen name="Exchange" component={Exchange} options={{ title: 'Exchange' }} />
    <stackRoutes.Screen name="Marketplace" component={Marketplace} options={{ title: 'Marketplace' }} />
    <stackRoutes.Screen name="Token" component={Token} options={{ title: 'Marketplace' }} />
    <stackRoutes.Screen name="BankAccount" component={BankAccount} options={{ title: 'Conta bancária' }} />
    <stackRoutes.Screen name="NewBankAccount" component={NewBankAccount} options={{ title: 'Adicionar conta bancária' }} />
    <stackRoutes.Screen name="EditBankAccount" component={EditBankAccount} options={{ title: 'Editar conta bancária' }} />
    <stackRoutes.Screen name="ChangePassword" component={ChangePassword} options={{ title: 'Trocar senha' }} />
    <stackRoutes.Screen name="NewPassword" component={NewPassword} options={{ title: 'Nova senha' }} />
    <stackRoutes.Screen name="MyCards" component={MyCards} options={{ title: 'Meus cartões' }} />
    <stackRoutes.Screen name="NewCard" component={NewCard} options={{ title: 'Adicionar cartão' }} />
    <stackRoutes.Screen name="EditCard" component={EditCard} options={{ title: 'Editar cartão' }} />
    <stackRoutes.Screen name="DeleteCard" component={DeleteCard} options={{ title: 'Deletar cartão' }} />
    <stackRoutes.Screen name="MarketplaceCategories" component={MarketplaceCategories} options={{ title: 'Marketplace - categorias' }} />
    <stackRoutes.Screen name="DetailsCoin" component={DetailsCoin} options={{ title: 'Detalhes da moeda' }} />
    <stackRoutes.Screen name="MoreInfosCoin" component={MoreInfosCoin} options={{ title: 'Mais informações' }} />
    <stackRoutes.Screen name="MyBalance" component={MyBalance} options={{ title: 'Meu saldo' }} />
    <stackRoutes.Screen name="ConfirmPassword" component={ConfirmPassword} options={{ title: 'Confirmar senha' }} />
    <stackRoutes.Screen name="ConfirmPasswordPurchaseOrSell" component={ConfirmPasswordPurchaseOrSell} options={{ title: 'Confirmar senha' }} />
    <stackRoutes.Screen name="ConfirmPasswordTransfer" component={ConfirmPasswordTransfer} options={{ title: 'Confirmar senha' }} />
    <stackRoutes.Screen name="SellExchange" component={SellExchange} options={{ title: 'Exchange - vender' }} />
    <stackRoutes.Screen name="ConfirmSell" component={ConfirmSell} options={{ title: 'Confirmar venda' }} />
    <stackRoutes.Screen name="Purchase" component={Purchase} options={{ title: 'Comprar' }} />
    <stackRoutes.Screen name="ConfirmPurchase" component={ConfirmPurchase} options={{ title: 'Confirmar compra' }} />
    <stackRoutes.Screen name="ConfirmPurchaseOrSell" component={ConfirmPurchaseOrSell} options={{ title: 'Confirmar transação' }} />
    <stackRoutes.Screen name="ConfirmTransfer" component={ConfirmTransfer} options={{ title: 'Confirmar transferência' }} />
    <stackRoutes.Screen name="PaymentMethod" component={PaymentMethod} options={{ title: 'Método de pagamento' }} />
    <stackRoutes.Screen name="BankSlip" component={BankSlip} />
    <stackRoutes.Screen name="CreditCardPayment" component={CreditCardPayment} options={{ title: 'Pagamento com cartão de crédito' }} />
    <stackRoutes.Screen name="Transfer" component={Transfer} options={{ title: 'Transferência' }} />
    <stackRoutes.Screen name="TransferFindUser" component={TransferFindUser} options={{ title: 'Transferência - Buscar usuário' }} />
    <stackRoutes.Screen name="PaymentMethodTransfer" component={PaymentMethodTransfer} options={{ title: 'Transferência - Método de pagamento' }} />
    <stackRoutes.Screen name="SearchUsers" component={SearchUsers} options={{ title: 'Buscar usuários' }} />
    <stackRoutes.Screen name="ConfirmSearchUser" component={ConfirmSearchUser} options={{ title: 'Transferência - Método de pagamento' }} />
    <stackRoutes.Screen name="SelectPixKey" component={SelectPixKey} options={{ title: 'Pix - Selecionar chave' }} />
    <stackRoutes.Screen name="PhonePix" component={PhonePix} options={{ title: 'Pix - Telefone' }} />
    <stackRoutes.Screen name="EmailPix" component={EmailPix} options={{ title: 'Pix - E-mail' }} />
    <stackRoutes.Screen name="IdentityDocumentPix" component={IdentityDocumentPix} options={{ title: 'Pix - Documento de identidade' }} />
    <stackRoutes.Screen name="RandomKeyPix" component={RandomKeyPix} options={{ title: 'Pix - Chave aleatória' }} />
    <stackRoutes.Screen name="BankAccountPix" component={BankAccountPix} options={{ title: 'Pix - Conta bancária' }} />
    <stackRoutes.Screen name="QrCodeTransferPix" component={QrCodeTransferPix} options={{ title: 'Pix - QRCode' }} />
    <stackRoutes.Screen name="QrCodeConfirmTransferPix" component={QrCodeConfirmTransferPix} options={{ title: 'Pix - Confirmar QRCode' }} />
    <stackRoutes.Screen name="PaymentMethodPay" component={PaymentMethodPay} options={{ title: 'Pay - Método de pagamento' }} />
    <stackRoutes.Screen name="QrCodePay" component={QrCodePay} options={{ title: 'Pay - QRCode' }} />
    <stackRoutes.Screen name="QrCodeConfirmPay" component={QrCodeConfirmPay} options={{ title: 'Pay -  Confirmar QRCode' }} />
    <stackRoutes.Screen name="BarCodePay" component={BarCodePay} options={{ title: 'Pay - Código de barras' }} />
    <stackRoutes.Screen name="BarCodeConfirmPay" component={BarCodeConfirmPay} options={{ title: 'Pay - Confirmar código de barras' }} />
    <stackRoutes.Screen name="Sell" component={Sell} options={{ title: 'Venda' }} />
    <stackRoutes.Screen name="PaymentMethodSell" component={PaymentMethodSell} options={{ title: 'Venda - Método de pagamento' }} />
    <stackRoutes.Screen name="ConfirmSearchUserSell" component={ConfirmSearchUserSell} options={{ title: 'Confirmar usuário' }} />
    <stackRoutes.Screen name="Cashback" component={Cashback} options={{ title: 'Cashback' }} />
    <stackRoutes.Screen name="MyQualification" component={MyQualification} options={{ title: 'Qualificação' }} />
    <stackRoutes.Screen name="LevelUpdate" component={LevelUpdate} options={{ title: 'Atualização de nível' }} />
    <stackRoutes.Screen name="InvestorProfile" component={InvestorProfile} options={{ title: 'Perfil do investidor' }} />
    <stackRoutes.Screen name="PurchaseMkt" component={PurchaseMkt} options={{ title: 'Marketplace - comprar' }} />
    <stackRoutes.Screen name="Certificates" component={Certificates} options={{ title: 'Certificado' }} />
    <stackRoutes.Screen name="CertificateEmit" component={CertificatesEmit} options={{ title: 'Emitir certificado' }} />
    <stackRoutes.Screen name="BuyExchange" component={BuyExchange} options={{ title: 'Exchange - comprar' }} />
    <stackRoutes.Screen name="BuyToken" component={BuyToken} options={{ title: 'Comprar' }} />
    <stackRoutes.Screen name="DepositMethod" component={DepositMethod} options={{ title: 'Método de depósito' }} />
    <stackRoutes.Screen name="DepositCryptoSelection" component={DepositCryptoSelection} options={{ title: 'Selecionar - Depositar criptoativo' }} />
    <stackRoutes.Screen name="DepositCrypto" component={DepositCrypto} options={{ title: 'Depósito criptoativo' }} />
    <stackRoutes.Screen name="DepositGPXAmount" component={DepositGPXAmount} options={{ title: 'Depósito' }} />
    <stackRoutes.Screen name="DepositPaymentMethod" component={DepositPaymentMethod} options={{ title: 'Depósito - método de pagamento' }} />
    <stackRoutes.Screen name="DepositPix" component={DepositPix} options={{ title: 'Depósito - pix' }} />
    <stackRoutes.Screen name="DepositBoleto" component={DepositBoleto} options={{ title: 'Depósito - boleto' }} />
    <stackRoutes.Screen name="DepositCreditCard" component={DepositCreditCard} options={{ title: 'Depósito - cartão de crédito' }} />
    <stackRoutes.Screen name="DepositNewCreditCard" component={DepositNewCreditCard} options={{ title: 'Depósito - novo cartão de crédito' }} />
    <stackRoutes.Screen name="DepositCreditCardSummary" component={DepositCreditCardSummary} options={{ title: 'Depósito - detalhes do cartão de crédito' }} />
    <stackRoutes.Screen name="WithdrawMethod" component={WithdrawMethod} options={{ title: 'Retirada - métodos de retirada' }} />
    <stackRoutes.Screen name="WithdrawGPXAccountSelection" component={WithdrawGPXAccountSelection} options={{ title: 'Retirada - Selecionar conta' }} />
    <stackRoutes.Screen name="WithdrawGPX" component={WithdrawGPX} options={{ title: 'Retirada - GPX' }} />
    <stackRoutes.Screen name="WithdrawCryptoSelection" component={WithdrawCryptoSelection} options={{ title: 'Retirar - Selecionar Crypto' }} />
    <stackRoutes.Screen name="WithdrawCrypto" component={WithdrawCrypto} options={{ title: 'Retirada - Crypto' }} />
    <stackRoutes.Screen name="WithdrawCryptoPassword" component={WithdrawCryptoPassword} options={{ title: 'Retirada - Senha Crypto' }} />
    <stackRoutes.Screen name="WithdrawGPXPassword" component={WithdrawGPXPassword} options={{ title: 'Retirada - Senha GPX' }} />    
    <stackRoutes.Screen name="PaperWallet" component={PaperWallet} options={{ title: 'Paper Wallet' }} />
    <stackRoutes.Screen name="ConfirmPaperWallet" component={ConfirmPaperWallet} options={{ title: 'Paper Wallet' }} />
    <stackRoutes.Screen name="ConfirmPasswordPaperWallet" component={ConfirmPasswordPaperWallet} options={{ title: 'Paper Wallet' }} />
    <stackRoutes.Screen name="PaperWalletDeposit" component={PaperWalletDeposit} options={{ title: 'Paper Wallet' }} />

  </stackRoutes.Navigator>
);

export default PageRoutes;
